import React from "react";
import DocumentTitle from "react-document-title";
import {UploadFiles} from "../../modules/UploadFiles";
import {UploadType} from "../../static/enums/UploadType";
import {Route, Switch} from "react-router-dom";
import {DefaultRoutes, TopicsRoutes} from "../../routes";
import {TopicsTablePage} from "./TopicsTablePage";
import {FeatureAppearance} from "../../modules/FeatureAppearance";
import {Redirect} from "react-router";

export default function TopicsPage() {
  return (
    <DocumentTitle title={"Темы - Mindset.Digital"}>
        <Switch>
            <Route exact path={`/${DefaultRoutes.topics}`} component={TopicsTablePage} />
            <Route path={`/${TopicsRoutes.files}`} component={UploadTopicsFiles} />
        </Switch>
    </DocumentTitle>
  );
}

function UploadTopicsFiles() {
  return (
    <FeatureAppearance feature={["questions.topics.any.create", "questions.topics.any.update"]}>
      {(featureExist) => {
        return featureExist
          ? (
            <div>
              <UploadFiles title={"XLS-файл с темами"} type={UploadType.topics} />
            </div>
          )
          : <Redirect to={"/page404"} />
      }}
    </FeatureAppearance>
  )
}